import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { AppShell } from '@/components/layout/AppShell';
import { ButtonLink, ErrorState } from '@/components/ui';
import { toApiError } from '@/lib/api/client';
import { paths } from '@/routes/paths';

/**
 * Catches render-time crashes per route so one broken component does not blank the
 * whole app.
 *
 * The reload button is a full page reload rather than a re-render: if a component
 * threw during render, its state is suspect, and "try again" that re-renders the
 * same broken tree just fails again in front of the user.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();

  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : 'This page ran into a problem';

  return (
    <AppShell title="Something went wrong" titleHidden>
      <ErrorState
        error={isRouteErrorResponse(error) ? new Error(error.statusText) : toApiError(error)}
        title={title}
        onRetry={() => {
          window.location.reload();
        }}
      />
      <div className="mt-4 flex justify-center">
        <ButtonLink to={paths.home} variant="ghost">
          Go to the home page
        </ButtonLink>
      </div>
    </AppShell>
  );
}
